'use client';

import { c as _c } from "react/compiler-runtime";
import { format } from '@eversports/dates';
import { usePathname, useSearchParams } from 'next/navigation';
import type { Locale } from '../../../../../../../../../localization/i18n';
import formatRelativeTodayTomorrowDate from '../../../../../../../../utils/format-relative-today-tomorrow-date';
import { FILTER_KEY_URL_PARAMS } from '../../Filters.types';
import DateFilterDropdown from './DateFilterDropdown';
import DateFilterSheet from './DateFilterSheet';
interface Props {
  handleRouteChange: (newRoute: string) => void;
  locale: Locale;
}
export default function DateFilter(t0) {
  const $ = _c(20);
  const {
    handleRouteChange,
    locale
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let resetFilter;
  let selectedDate;
  let t1;
  let updateFilter;
  if ($[0] !== handleRouteChange || $[1] !== locale || $[2] !== pathname || $[3] !== searchParams) {
    const params = new URLSearchParams(searchParams.toString());
    const activeFilter = params.get(FILTER_KEY_URL_PARAMS.DATE);
    selectedDate = activeFilter ? new Date(activeFilter) : undefined;
    updateFilter = dateSelection => {
      if (dateSelection) {
        const formattedDate = format(dateSelection, "yyyy-MM-dd");
        params.set(FILTER_KEY_URL_PARAMS.DATE, formattedDate);
      } else {
        params.delete(FILTER_KEY_URL_PARAMS.DATE);
      }
      handleRouteChange(`${pathname}?${params.toString()}`);
    };
    resetFilter = () => {
      params.delete(FILTER_KEY_URL_PARAMS.DATE);
      handleRouteChange(`${pathname}?${params.toString()}`);
    };
    t1 = selectedDate && formatRelativeTodayTomorrowDate({
      date: selectedDate,
      locale
    });
    $[0] = handleRouteChange;
    $[1] = locale;
    $[2] = pathname;
    $[3] = searchParams;
    $[4] = resetFilter;
    $[5] = selectedDate;
    $[6] = t1;
    $[7] = updateFilter;
  } else {
    resetFilter = $[4];
    selectedDate = $[5];
    t1 = $[6];
    updateFilter = $[7];
  }
  const formattedDate_0 = t1;
  let t2;
  if ($[8] !== formattedDate_0 || $[9] !== resetFilter || $[10] !== selectedDate || $[11] !== updateFilter) {
    t2 = <DateFilterSheet selectedDate={selectedDate} formattedDate={formattedDate_0} updateFilter={updateFilter} resetFilter={resetFilter} />;
    $[8] = formattedDate_0;
    $[9] = resetFilter;
    $[10] = selectedDate;
    $[11] = updateFilter;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== formattedDate_0 || $[14] !== selectedDate || $[15] !== updateFilter) {
    t3 = <DateFilterDropdown selectedDate={selectedDate} formattedDate={formattedDate_0} updateFilter={updateFilter} />;
    $[13] = formattedDate_0;
    $[14] = selectedDate;
    $[15] = updateFilter;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t2 || $[18] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}